import storage from "store";
import expirePlugin from "store/plugins/expire";
import { getUserInfo } from "@/api/LogonFree";
import { ACCESS_TOKEN } from "@/store/mutation-types";
// import { welcome } from '@/utils/util'

storage.addPlugin(expirePlugin);
const user = {
  state: {
    token: "",
    name: "",
    // welcome: '',
    avatar: "",
    roles: [],
    info: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    // SET_NAME: (state, { name, welcome }) => {
    //   state.name = name
    //   state.welcome = welcome
    // },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
  },

  actions: {
    // // 登录
    // Login ({ commit }, userInfo) {
    //   return new Promise((resolve, reject) => {
    //     login(userInfo).then(response => {
    //       const result = response.result
    //       storage.set(ACCESS_TOKEN, result.token, new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
    //       commit('SET_TOKEN', result.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // 先写死一个假信息
        // const userInfo = {
        //   result: {
        //     role: {
        //       id: "admin",
        //       name: "管理员",
        //       describe: "拥有所有权限",
        //       status: 1,
        //       creatorId: "system",
        //       createTime: 1497160610259,
        //       deleted: 0,
        //       permissions: [
        //         {
        //           roleId: "admin",
        //           permissionId: "hourSystem",
        //           permissionName: "工时申报飞书",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "dashboard",
        //           permissionName: "仪表盘",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "hoursDeclaration",
        //           permissionName: "工时申报",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "statisticalReport",
        //           permissionName: "统计报表",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "system",
        //           permissionName: "系统设置",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "workHoursLibrary",
        //           permissionName: "标准工时库",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "operationMaintenance",
        //           permissionName: "运维日志",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "thirdParty",
        //           permissionName: "第三方集成",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //         {
        //           roleId: "admin",
        //           permissionId: "userManage",
        //           permissionName: "用户管理",
        //           actionEntitySet: [
        //             {
        //               action: "query",
        //               describe: "查询",
        //               defaultCheck: false,
        //             },
        //           ],
        //         },
        //       ],
        //       permissionList: [
        //         "hourSystem",
        //         "dashboard",
        //         "hoursDeclaration",
        //         "statisticalReport",
        //         "system",
        //         "workHoursLibrary",
        //         "operationMaintenance",
        //         "thirdParty",
        //         "userManage",
        //       ],
        //     },
        //   },
        // };
        // const { result } = userInfo;
        // if (result.role && result.role.permissions.length > 0) {
        //   const role = { ...result.role };
        //   role.permissions = result.role.permissions.map((permission) => {
        //     const per = {
        //       ...permission,
        //       actionList: (permission.actionEntitySet || {}).map(
        //         (item) => item.action
        //       ),
        //     };
        //     return per;
        //   });
        //   role.permissionList = role.permissions.map((permission) => {
        //     return permission.permissionId;
        //   });
        //   // 覆盖响应体的 role, 供下游使用
        //   result.role = role;

        //   commit("SET_ROLES", role);
        //   commit("SET_INFO", result);
        //   // commit('SET_NAME', { name: result.name, welcome: welcome() })
        //   commit("SET_AVATAR", result.avatar);
        //   // 下游
        //   resolve(result);
        // } else {
        //   reject(new Error("getInfo: roles must be a non-null array !"));
        // }

        // 请求后端获取用户信息 /api/user/info
        getUserInfo()
          .then((response) => {
            const { data } = response;
            // console.log(data && data.userAuth.menuList.length > 0);
            if (data && data.userAuth.menuList.length > 0) {
              const role = { ...data.userAuth };
              var permissions = data.userAuth.menuList.map((permission) => {
                const per = {
                  ...permission,
                  actionList: (permission.children || {}).map(
                    (item) => {return {name:item.name,path:item.path}}
                  ),
                };
                return per;
              });
              var permissionList = [];
              permissions.map((permission) => {
                permissionList.push({
                  name: permission.name,
                  path: permission.path,
                });
                if (permission.actionList) {
                  permissionList.push.apply(
                    permissionList,
                    permission.actionList
                  );
                }
              });
              console.log(permissionList);
              // 覆盖响应体的 role, 供下游使用
              console.log(role);
              role.permissionList = permissionList;
              data.role = role;
              console.log(data);
              commit("SET_ROLES", role);
              commit("SET_INFO", data);
              // commit('SET_NAME', { name: result.name, welcome: welcome() })
              commit("SET_AVATAR", data.avatar);
              // 下游
              resolve(data);
            } else {
              reject(new Error("getInfo: roles must be a non-null array !"));
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    // // 登出
    // Logout ({ commit, state }) {
    //   return new Promise((resolve) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       storage.remove(ACCESS_TOKEN)
    //       resolve()
    //     }).catch((err) => {
    //       console.log('logout fail:', err)
    //       // resolve()
    //     }).finally(() => {
    //     })
    //   })
    // }
  },
};

export default user;
